import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom';
import { routes } from './routes';
import AppMainLayout from './layout/AppMainLayout';
import NotFoundPage from '../../containers/NotFoundPage/Loadable';
import { useHistory } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
var AppBuilderSubRouter = function () {
    var _a;
    var history = useHistory();
    var pathNameArray = history.location.pathname.split('/');
    return (_jsx(AppMainLayout, { children: !(pathNameArray[5] === 'structure' || ((_a = pathNameArray[5]) === null || _a === void 0 ? void 0 : _a.length) === 19) ? (_jsxs(Switch, { children: [routes.map(function (_a) {
                    var path = _a.path, pageComponent = _a.pageComponent, pageRenderer = _a.pageRenderer;
                    return pageComponent ? (_jsx(Route, { exact: true, path: path, component: pageComponent }, path)) : (_jsx(Route, { exact: true, path: path, render: pageRenderer }, path));
                }), _jsx(Route, { component: NotFoundPage }, "not-found")] })) : null }));
};
export default AppBuilderSubRouter;
